export class CodePathNotImplementedError extends Error {
  constructor() {
    super(`code path not implemented`)
  }
}
